module.exports = __webpack_public_path__ + "static/media/21ECLAC41.fc99590c.jpg";